export default __webpack_public_path__ + "static/media/action-cam-4.c40e49c0.png";